export default __webpack_public_path__ + "static/media/tg_logo_black.beb9d943.png";